import { ViewEntityDialog } from "components/viewDialog/ViewEntityDialog";
import { IViewEntityField } from "components/viewDialog/ViewEntityDialog.types";
import { ANNOUNCEMENT_TYPE_LABELS } from "models/IAnnouncement";
import { formatDate } from "utils/generalUtils";
import { IViewAnnouncementProps } from "./ViewAnnouncement.types";

export const ViewAnnouncement = (
  props: IViewAnnouncementProps,
): JSX.Element => {
  const { announcement, isOpen, onDismiss } = props;

  const typeLabel = announcement.type
    ? ANNOUNCEMENT_TYPE_LABELS[announcement.type] ?? announcement.type
    : "-";

  const fields: IViewEntityField[] = [
    { label: "Title", value: announcement.title },
    {
      label: "Content",
      value: (
        <div
          dangerouslySetInnerHTML={{
            __html: announcement.content || "-",
          }}
        />
      ),
    },
    { label: "Type", value: typeLabel },
    { label: "Enabled", value: announcement.enabled ? "Yes" : "No" },
    { label: "Author", value: announcement.displayName || "-" },
    { label: "Last Updated", value: formatDate(announcement.updatedAt) },
  ];

  return (
    <ViewEntityDialog
      isOpen={isOpen}
      onDismiss={onDismiss}
      title="View Announcement"
      fields={fields}
    />
  );
};
